import { Container } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { deleteLocalStoarge } from '../../utils/localStorageActions'
import HeroSection from '../HeroSection/HeroSection'
import InputSection from './InputSection'
import ResultSection from './ResultSection'

const MainSection = () => {
    const [results, setResults] = useState([])
    const deleteResults = () => {
        deleteLocalStoarge()
        setResults([])
    }
    useEffect(() => {
        let savedResults = localStorage.getItem('OpenAIresults')
        if (savedResults) setResults(JSON.parse(savedResults))
    }, [])

    return (
        <Container component='main' maxWidth='lg'>
            <HeroSection />
            <InputSection setResults={setResults} />
            <ResultSection results={results} deleteResults={deleteResults} />
        </Container>
    )
}

export default MainSection